<template>
    <div id="loginContainer" >
        <div class="wow fadeInDown">
            <transition name="fade" mode="out-in">
                <div v-if="!isLoading" class="login p-1" >
                    <form class="loginContainer">
                        <img class="loginLogo"  alt='login logo' :src="conspectLogo">
                        <label for="loginInput" class="text-a-l">Adres email</label>
                        <input id="loginInput" v-model="email"  type="email" placeholder="Adres e-mail"/>
                        <label for="passwordInput" class="text-a-l">Hasło</label>
                        <input id="passwordInput" v-model="password" type="password" placeholder="Hasło"/>
                        <button class="button-p button-md m-t-3" @click.prevent="login" size="md" variant="outline-light">Zaloguj się</button>
                        <small class='m-t-2'>Nie masz jeszcze konta? <a href="https://centrumklubu.pl/register" >Utwórz je tutaj</a></small>
                        <small class='m-t-2'>Zapomniałeś hasło? <a href="https://centrumklubu.pl/password-reset" >Przypomnij</a></small>
                    </form>
                </div>
                <div v-else class="login p-5">
                    <loader class="p-5"></loader>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import conspectLogo from '../assets/conspectLogo.svg'
    import Loader from '../components/Loader'

    export default {
        components: {
            'loader':Loader
        },
        data: () => (
            {
                email: null,
                password: null,
                isLoading: false,
                loginSuccess: true,
                isLogin: true,
                conspectLogo: conspectLogo,
                registerData:{
                    firstname:'',
                    lastname:'',
                    email:''
                }
            }
        ),
        methods: {
            showModal(name){$(name).showModal()},
            hideModal(name){$(name).hideModal()},
            login () {

                try {
                    let valid = new window.Validator({
                        "adres email": this.email,
                        "hasło": this.password
                    });
                    valid.get("adres email").length(3,50);
                    valid.get("hasło").length(5,50);
                }catch (e) {
                    return
                }

                this.isLoading = true;

                window.axios.post('/auth/login', {
                    email: this.email,
                    password: this.password,
                    place: "conspect"
                })
                    .then((response) => {
                        window.AuthMiddleware.login(response.data);
                        this.$router.push( (this.$route.query.redirect && this.$route.query.redirect.length > 0)? this.$route.query.redirect : '/');
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            }
        },
        mounted: function(){
            // if (!navigator.serviceWorker.controller) {
            //     navigator.serviceWorker.register('./serviceWorker.js', {
            //         scope: './'
            //     }).then(function(reg) {
            //         console.log('Service worker has been registered for scope:'+ reg.scope);
            //     });
            // }
        }
    }
</script>

<style>

</style>
